import { render, staticRenderFns } from "./ObjectHistoryView.vue?vue&type=template&id=c561f8c0&scoped=true&"
import script from "./ObjectHistoryView.vue?vue&type=script&lang=js&"
export * from "./ObjectHistoryView.vue?vue&type=script&lang=js&"
import style0 from "./ObjectHistoryView.vue?vue&type=style&index=0&id=c561f8c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c561f8c0",
  null
  
)

export default component.exports